import { render, staticRenderFns } from "./gateWay.vue?vue&type=template&id=324d5e88&scoped=true&"
import script from "./gateWay.vue?vue&type=script&lang=js&"
export * from "./gateWay.vue?vue&type=script&lang=js&"
import style0 from "./gateWay.vue?vue&type=style&index=0&id=324d5e88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324d5e88",
  null
  
)

export default component.exports